import { render, staticRenderFns } from "./TestReportListItem.vue?vue&type=template&id=21b68400&scoped=true&"
import script from "./TestReportListItem.vue?vue&type=script&lang=js&"
export * from "./TestReportListItem.vue?vue&type=script&lang=js&"
import style0 from "./TestReportListItem.vue?vue&type=style&index=0&id=21b68400&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b68400",
  null
  
)

export default component.exports